import React from "react";
import * as FaIcons from "react-icons/fa";

import livingStatusList from "../../../data/livingStatusList";
import states from "../../../data/states";

const R4PhysicalAddress = ({ formData, onFormDataChange, validationCheck }) => {
  const {
    registerForIntercession,
    firstName,
    liveWithPg,
    livingStatus,
    street,
    city,
    state,
    zip,
    county,
    isMailingAddressTheSame,
  } = formData;
  return (
    <>
      {/* Physical Address */}
      <div className="sub-form">
        <h3>Physical Address</h3>
        {!registerForIntercession && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Does {firstName === "" ? "the Student" : firstName} live with
                  Parents?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck && !(liveWithPg["yes"] || liveWithPg["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={liveWithPg["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="liveWithPg"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={liveWithPg["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="liveWithPg"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
          </>
        )}

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the Student" : firstName}'s Living
              Status
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>

          <select
            name="livingStatus"
            value={livingStatus}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(livingStatus !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {livingStatusList.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Street</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="street"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={street}
            style={{
              border:
                validationCheck && !(street !== "") ? "2px solid #d8302f" : "",
            }}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>City</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="city"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={city}
            style={{
              border:
                validationCheck && !(city !== "") ? "2px solid #d8302f" : "",
            }}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>State</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="state"
            value={state}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(state !== "") ? "2px solid #d8302f" : "",
            }}
          >
            <option value="">Please Select </option>
            {states.map((item) => {
              return (
                <option value={Object.keys(item)}>{Object.keys(item)}</option>
              );
            })}
          </select>
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Zip</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="zip"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={zip}
            style={{
              border:
                validationCheck && !(zip !== "") ? "2px solid #d8302f" : "",
            }}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>County</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="county"
            value={county}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(county !== "") ? "2px solid #d8302f" : "",
            }}
          />
          
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Is Mailing Address the Same?</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  isMailingAddressTheSame["yes"] ||
                  isMailingAddressTheSame["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={isMailingAddressTheSame["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="isMailingAddressTheSame"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={isMailingAddressTheSame["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="isMailingAddressTheSame"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default R4PhysicalAddress;
